import {
  isAnnouncementPitchType,
  isResearchPitchType,
  isThoughtLeadershipPitchType,
  MailingObjectivesFormType,
  PitchType,
} from '@mailings/components/creators/personalized-mailing-creator-wizard/types/mailingObjectivesForm.types';
import {
  isPersonalizedAnnouncementGenerationInput,
  isPersonalizedLeadershipGenerationInput,
  isPersonalizedResearchGenerationInput,
  Mailing,
} from '@mailings/types/mailings.types';

export const getMailingObjectivesFormValues = (
  sourceMailing: Mailing | null | undefined,
): MailingObjectivesFormType | null => {
  const generation = sourceMailing?.generation;

  if (!generation || generation.status === 'error' || generation.status === 'in_progress') {
    return null;
  }

  const pitchType = generation.flow as PitchType;
  const generationInput = generation.input;
  const baseFields = {
    brandHubDomainId: sourceMailing.brandHubDomainId ?? undefined,
    language: generation.language,
    toneOfVoice: generation.toneOfVoice,
  };

  if (
    isAnnouncementPitchType(pitchType) &&
    isPersonalizedAnnouncementGenerationInput(generationInput)
  ) {
    return {
      ...baseFields,
      pitchType: 'personalization_announcement',
      storyGoal: generationInput.storyGoal ?? '',
      storyLink: generationInput.storyLink ?? undefined,
      storyDocumentFile: generationInput.storyDocumentFile ?? undefined,
      isEarlyAccess: generationInput.isEarlyAccess ?? false,
      earlyAccessExpireDate: generationInput.earlyAccessExpireDate ?? undefined,
      campaignIdeationId: generationInput.campaignIdeationId,
      brandHubStoryId: generationInput.brandHubStoryId ?? undefined,
      brandHubStoryTitle: generationInput.brandHubStoryTitle ?? undefined,
    };
  }

  if (isResearchPitchType(pitchType) && isPersonalizedResearchGenerationInput(generationInput)) {
    return {
      ...baseFields,
      pitchType: 'personalization_research',
      researchFindings: generationInput.researchFindings ?? '',
      researchDescription: generationInput.researchDescription ?? '',
      researchSources: generationInput.researchSources ?? '',
      storyLink: generationInput.storyLink ?? undefined,
      storyDocumentFile: generationInput.storyDocumentFile ?? undefined,
      campaignIdeationId: generationInput.campaignIdeationId,
      brandHubResourceId: generationInput.brandHubResourceId ?? undefined,
      brandHubResourceName: generationInput.brandHubResourceName ?? undefined,
    };
  }

  if (
    isThoughtLeadershipPitchType(pitchType) &&
    isPersonalizedLeadershipGenerationInput(generationInput)
  ) {
    return {
      ...baseFields,
      pitchType: 'personalization_leadership',
      expertVoiceId: generationInput.expertVoiceId,
      expertName: generationInput.expertName ?? '',
      expertRole: generationInput.expertRole ?? '',
      expertIntroduction: generationInput.expertIntroduction ?? '',
      expertReasoning: generationInput.expertReasoning ?? '',
      campaignIdeationId: generationInput.campaignIdeationId,
    };
  }

  return null;
};
